import { type MutationFunction, useMutation } from '@tanstack/react-query';
import Api from 'hooks/Api';
import { useProvider } from 'utils/providers/Provider';

export default function useVerifyOtpV3() {
  const { state } = useProvider();
  const args = state;

  const mutationFn: MutationFunction<any> = async (payload) => {
    const api = new Api(args);

    const data = await api.post({
      url: 'api/v3/auth/accounts/otp/verify',
      payload,
    });

    return data;
  };

  return useMutation({
    mutationFn,
  });
}
